/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { ModalGlobal } from '../modal/modal.Global';
import { deepCloneArray } from '../../utils/array';
import { getId } from '../../utils/item';
import { update } from '../../services/item';
import React from 'react';
import {
  WidgetSettingsRoot,
  WidgetSettingsCollapsibleSection,
  DangerZone,
  SettingsInput,
} from '../form/settings.Widget';

export const IframSettings = props => {
  const { itemId, iframeId, iframe, canEdit = true } = props;

  const item = useSelector(state => state.items[itemId]);

  const deleteIframe = () => {
    if (!canEdit) {
      return;
    }
    if (!item?.iframes) return;

    const clonedIframes = deepCloneArray(item.iframes);
    const iframeIdx = clonedIframes.findIndex(
      iframeObj => getId(iframeObj) === iframeId
    );
    if (iframeIdx > -1) {
      clonedIframes.splice(iframeIdx, 1);
      update(`items/${itemId}`, 'iframes', clonedIframes);
    }
  };

  const updateField = (value, field) => {
    if (!canEdit) {
      return;
    }
    const clonedIframes = deepCloneArray(item.iframes);
    const iframeIdx = clonedIframes.findIndex(
      iframeObj => getId(iframeObj) === iframeId
    );
    if (iframeIdx > -1) {
      clonedIframes[iframeIdx][iframeId][field] = value;
      update(`items/${itemId}`, 'iframes', clonedIframes);
    }
  };

  if (!canEdit) {
    return null;
  }

  return (
    <ModalGlobal
      title='edition'
      idToOpen={iframeId}
    >
      <WidgetSettingsRoot>
        <WidgetSettingsCollapsibleSection title='Général' defaultOpen={true}>
          <SettingsInput
            placeholder={'label'}
            initValue={iframe?.label}
            onBlur={value => updateField(value, 'label')}
          />
          <SettingsInput
            placeholder={'url'}
            initValue={iframe?.url}
            onBlur={value => updateField(value, 'url')}
          />
        </WidgetSettingsCollapsibleSection>
        <DangerZone
          confirmId={'delete' + iframeId + itemId}
          closeModalId={iframeId}
          message='Voulez-vous vraiment supprimer cette iframe ?'
          onConfirm={deleteIframe}
        />
      </WidgetSettingsRoot>
    </ModalGlobal>
  );
};
